import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { Text } from "../UI";
import ShowChangeDocButton, { AlertHexIcon } from "./ShowChangeDocButton";

const SHADOW = "0px 8px 24px rgba(91, 115, 134, 0.18)";

const ChangeSignPopover = ({ tenantsChooseStore }) => {
  const theme = useTheme();
  const { t } = useTranslation("lobby");

  if (tenantsChooseStore?.isChangeDocSigned) return null;

  return (
    <div
      style={{
        position: "relative",
        width: 340,
        backgroundColor: theme.color.white,
        borderRadius: 24,
        boxShadow: SHADOW,
        padding: 24,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 16,
      }}
    >
      <AlertHexIcon color={theme.color.navy} size={28} />

      <Text.BB color={theme.color.navy} style={{ textAlign: "center" }}>
        {t("changes_sign_prompt")}
      </Text.BB>

      <ShowChangeDocButton />

      <div
        style={{
          position: "absolute",
          top: "50%",
          right: -8,
          width: 16,
          height: 16,
          backgroundColor: theme.color.white,
          transform: "translateY(-50%) rotate(45deg)",
          boxShadow: SHADOW,
        }}
      />
    </div>
  );
};

export default inject("tenantsChooseStore")(observer(ChangeSignPopover));
